import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './Paragraph.module.css';

class Paragraph extends PureComponent {
  render() {
    const { children } = this.props;
    return <p styleName="paragraph">{children}</p>;
  }
}

Paragraph.propTypes = {
  children: PropTypes.node
};

export default Paragraph;
